export default __webpack_public_path__ + "static/media/A5.ec4bfcb3.png";